import src from "IMAGE";
export default { src, width: 710, height: 702, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
